import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type UserAvatarSpecsFragment = (
  { __typename: 'User' }
  & Pick<SchemaTypes.User, 'id' | 'displayName'>
  & { profileImage?: SchemaTypes.Maybe<(
    { __typename: 'UploadedFileWithPreview' }
    & Pick<SchemaTypes.UploadedFileWithPreview, 'id' | 'url'>
  )> }
);

export const UserAvatarSpecsFragmentDoc = /*#__PURE__*/ gql`
    fragment UserAvatarSpecs on User {
  id
  displayName
  profileImage {
    id
    url
  }
}
    `;